import React, { Component } from 'react';
import './Quote.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';

class Quote extends Component {

  componentDidMount(){
    AOS.init({
      duration : 1200,
      disable: 'mobile'
    })
  }

  render() {
    let size = "";

    if(this.props.QuoteSize){
      size = "contain-img"
    }

    return (
      <div className={`d-flex align-items-center quote ${this.props.classes}`}>
        <div className="content-wrapper container-fluid">
          <div data-aos='fade-up' className="row d-flex align-items-center">
            <div className="col-12 col-lg-4 offset-lg-1">
              <h3 className="quote">{this.props.quote}</h3>
              <p className="author">
                {this.props.author}
                {/* eslint-disable-next-line react/jsx-no-target-blank */}
                <a href={'//'+this.props.website} target='_blank' ><i><p>{this.props.website}</p></i></a>
              </p>
            </div>
            <div className="col-12 col-lg-6">
              <img src={"../../img/L'authentique.jpg"} alt=""/>
              <div className={"authentique " + size} style={{backgroundImage: "url(" + this.props.image + ")",backgroundSize: 'cover', backgroundPosition: 'center'}}>

              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default Quote;
